<template>
  <div class='app_container'>
    <div class="app_shell">
      <div class="top_header">
        <a class="header_logo_link" href='https://www.contentos.io'>
          <img class='header_logo' src='../../assets/img/Contentos_logo.svg' alt='Contentos'>
        </a>
        <div class="language_bg">
          <el-dropdown>
            <div>{{curLanguage}}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in languageList" :key='index' @click.native="changeLanguage(item.languageType)" >
                {{item.language}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="language-arrow-down"></div>
        </div>
      </div>

      <div class="panel_header">
        <div class="panel_title">{{ $t('message.conversion_record') }}</div>
        <div class="panel_subtitle">{{ $t('message.panel_subtitle_status') }}</div>
      </div>

      <div class="operate_container">
        <conversionStatusView></conversionStatusView>
        <div class="action_row">
          <button class="secondary_btn" @click="goBack"><span>{{$t('message.go_back')}}</span></button>
        </div>
      </div>

      <el-footer>
        <a class="service_mail" href='mailto:service@contentos.io'>service@contentos.io</a>
        <span class="footer_copyright">© 2018 - {{ currentYear }} COS FOUNDATION</span>
      </el-footer>
    </div>
  </div>
</template>

<script>
import conversionStatusView from '../../components/v2/conversionStatusView'
import i18n from '../../i18n/i18n'
import utils from '../../common/v2/utils'

export default {
  name: 'records',
  components: {
    conversionStatusView
  },
  data () {
    return {
      languageList: this.getLanguageList(),
      curLanguageType: utils.languageType.languageTypeEn,
      curLanguage: 'English',
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    getCurrentLanguageType () {
      let local = i18n.locale
      if (utils.checkIsSupportLanguage(local)) {
        return i18n.locale
      } else {
        this.$i18n.locale = utils.languageType.languageTypeEn
      }
      return utils.languageType.languageTypeEn
    },

    getCurrentLanguage () {
      for (let info of this.languageList) {
        if (this.curLanguageType === info.languageType) {
          return info.language
        }
      }
      return 'English'
    },

    changeLanguage (val) {
      if (this.curLanguageType !== val) {
        for (let info of this.languageList) {
          if (info.languageType === val) {
            this.curLanguage = info.language
            this.curLanguageType = val
            this.$i18n.locale = val
            sessionStorage.setItem('locale', val)
          }
        }
      }
    },

    getLanguageList () {
      return [{ languageType: utils.languageType.languageTypeTW, language: '繁體中文' },
        { languageType: utils.languageType.languageTypeCN, language: '简体中文' },
        { languageType: utils.languageType.languageTypeEn, language: 'English' },
        { languageType: utils.languageType.languageTypeKo, language: '한국어' },
        { languageType: utils.languageType.languageTypeVietnam, language: 'Tiếng việt' },
        { languageType: utils.languageType.languageTypeRussian, language: 'Русский' }]
    },

    goBack () {
      this.$router.back()
    }
  },
  mounted () {
    this.curLanguageType = this.getCurrentLanguageType()
    this.curLanguage = this.getCurrentLanguage()
  }
}
</script>

<style scoped>
  .app_container {
    width: 100%;
    min-height: 100vh;
    font-family: "Poppins", "PingFang TC", "Noto Sans TC", sans-serif;
    background: #f9fafb;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .app_shell {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 64px;
    margin-bottom: 64px;
    min-height: calc(100vh - 128px);
    padding: 16px 20px 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .top_header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 64px;
    padding: 0 32px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-bottom: 1px solid #e4e4e7;
    z-index: 100;
  }

  .header_logo_link {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
  }

  .header_logo {
    width: 135px;
    height: 43px;
    object-fit: contain;
    display: block;
  }

  .language_bg {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    color: #374151;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }

  .language_bg .el-dropdown {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  .language-arrow-down {
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #71717a;
    margin-left: 5px;
    margin-top: 1px;
    pointer-events: none;
  }

  .panel_header {
    width: 100%;
    text-align: center;
    margin-bottom: 32px;
  }

  .panel_title {
    color: #0d0d0d;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: -0.5px;
    line-height: 1.2;
    text-align: center;
  }

  .panel_subtitle {
    margin-top: 10px;
    color: #70757f;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
  }

  .operate_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    box-sizing: border-box;
  }

  .action_row {
    width: 50%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
  }

  .action_row > .secondary_btn {
    width: 100%;
    max-width: none;
    margin-bottom: 0;
  }

  .secondary_btn {
    width: 100%;
    max-width: 300px;
    height: 48px;
    padding: 0;
    outline-style: none;
    border: 1px solid #6a11cb;
    border-radius: 0;
    background: #fff;
    color: #6a11cb;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }

  .secondary_btn span {
    color: inherit;
  }

  .secondary_btn:hover {
    opacity: 0.7;
  }

  .el-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    padding: 16px 40px !important;
    box-sizing: border-box;
    border-top: 1px solid #e4e4e7;
    background: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    z-index: 100;
  }

  .service_mail {
    color: #80848d;
    text-decoration: none;
    font-size: 13px;
  }

  .footer_copyright {
    color: #80848d;
    font-size: 12px;
  }

  @media (max-width: 600px) {
    .app_shell {
      padding: 12px 12px 4px;
    }

    .top_header {
      padding: 0 12px;
    }

    .el-footer {
      padding: 16px 12px !important;
    }

    .action_row {
      width: 100%;
    }

    .secondary_btn {
      max-width: none;
    }
  }
</style>
